import { store } from '../store/store';
export class ApiResponseModel {
    constructor(result, data = null, errorMessage = null) {
        this.result = result;
        this.data = data;
        this.errorMessage = errorMessage;
    }
}
export async function getAccessToken(licenseSerialNumber, userId) {
    const res = await fetch(`/api/getAccessToken`, {
        headers: { 'Authorization': `Bearer ${licenseSerialNumber}`, 'UserId': userId }
    });
    if (!res.ok) {
        return null;
    }
    return await res.text();
}
let continuationToken = null;
export function hasMoreChats() {
    return continuationToken !== null;
}
export function resetChatsPagination() {
    continuationToken = null;
}
export async function getRecentChats() {
    const state = store.getState();
    const res = await fetch(`/api/getRecentChats?userId=${state.rootData.userId}${continuationToken ? `&continuationToken=${continuationToken}` : ''}`, {
        headers: { 'Authorization': `Bearer ${state.rootData.token}` }
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
        return new ApiResponseModel(false, null, `${res.status}: ${await res.text()}`);
    }
    const data = await res.json();
    continuationToken = data.continuationToken;
    return new ApiResponseModel(true, data.chats, null);
}
export async function getChatHistory() {
    const state = store.getState();
    const res = await fetch(`/api/getChatHistory?chatId=${state.chat.currentChatId}`, {
        headers: { 'Authorization': `Bearer ${state.rootData.token}` }
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
        return new ApiResponseModel(false, null, `${res.status}: ${await res.text()}`);
    }
    const data = await res.json();
    return new ApiResponseModel(true, data, null);
}
export async function newChat() {
    const state = store.getState();
    const res = await fetch(`/api/newChat?userId=${state.rootData.userId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${state.rootData.token}` }
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
        return new ApiResponseModel(false, null, `${res.status}: ${await res.text()}`);
    }
    const data = await res.json();
    return new ApiResponseModel(true, data, null);
}
export async function getChatName(chatId) {
    const state = store.getState();
    const res = await fetch(`/api/getChatName?chatId=${chatId}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${state.rootData.token}` }
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
    }
    return await res.text();
}
export async function sendMessageToChat(input) {
    const state = store.getState();
    const res = await fetch('/api/chat', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.rootData.token}`
        },
        body: JSON.stringify({ chatId: state.chat.currentChatId, message: input })
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
        return new ApiResponseModel(false, null, `${res.status}: ${await res.text()}`);
    }
    return new ApiResponseModel(true, await res.text(), null);
}
export async function sendMessageToChatStream(chatId, input, cbs = {}) {
    const state = store.getState();
    const res = await fetch('/api/chat/stream', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.rootData.token}`,
        },
        body: JSON.stringify({ chatId, message: input }),
        signal: cbs.signal,
    });
    if (!res.ok) {
        if (res.status === 401)
            document.location.reload();
        cbs.onError?.(`${res.status}: ${await res.text()}`);
        return;
    }
    if (!res.body) {
        cbs.onError?.('Порожнє тіло відповіді');
        return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';
    while (true) {
        const { value, done } = await reader.read();
        if (done)
            break;
        buffer += decoder.decode(value, { stream: true });
        let idx;
        while ((idx = buffer.indexOf('\n\n')) >= 0) {
            const frame = buffer.slice(0, idx).trim();
            buffer = buffer.slice(idx + 2);
            const lines = frame.split('\n');
            let eventType = 'message';
            const dataLines = [];
            for (const line of lines) {
                if (line.startsWith('event:'))
                    eventType = line.slice(6).trim();
                else if (line.startsWith('data:'))
                    dataLines.push(line.slice(5).trim());
            }
            const data = dataLines.join('\n');
            if (eventType === 'done')
                cbs.onDone?.();
            else if (eventType === 'error')
                cbs.onError?.(data);
            else
                cbs.onChunk?.(data.replace(/\\n/g, '\n'));
        }
    }
}
